import i18n from 'i18n-js';

import { BaseballMlb, BaseballSimple } from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const BASEBALL_COMPONENTS = {
  [TEMPLATES_TITLES.BASEBALL_MLB]: BaseballMlb,
  [TEMPLATES_TITLES.BASEBALL_SIMPLE]: BaseballSimple,
};

export const BASEBALL_DESIGNS_DATA = {
  [TEMPLATES_TITLES.BASEBALL_MLB]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.BASEBALL_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.teamNamesDesign'),
          value: 'teamName',
          items: [
            {
              id: 101,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.pointsDesign'),
          value: 'points',
          items: [
            {
              id: 201,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.inningDesign'),
          value: 'inningStyle',
          items: [
            {
              id: 301,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 302,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 303,
              label: i18n.t('screens.builder.design.activateColor'),
              type: 'color',
              value: 'active',
            },
            {
              id: 304,
              label: i18n.t('screens.builder.design.inactiveColor'),
              type: 'color',
              value: 'inactive',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.baseDesign'),
          value: 'basesStyle',
          items: [
            {
              id: 401,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 402,
              label: i18n.t('screens.builder.design.activateColor'),
              type: 'color',
              value: 'active',
            },
            {
              id: 403,
              label: i18n.t('screens.builder.design.inactiveColor'),
              type: 'color',
              value: 'inactive',
            },
          ],
        },
        {
          id: 5,
          title: i18n.t('screens.builder.design.countDesign'),
          value: 'countStyle',
          items: [
            {
              id: 501,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 502,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
};

export default {
  BASEBALL_COMPONENTS,
  BASEBALL_DESIGNS_DATA,
};
